export default "__VITE_ASSET__DJTwGhLB__"